var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBitaMethodologyIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Bita - Methodology - Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bita---Methodology---Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#2962FF",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "M",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "5 27 5 5 11.1269841 5 15.984127 22.1824818 20.8412698 5 27 5 27 27 23.4444444 27 23.4444444 8.95036496 22.968254 8.95036496 17.8253968 26.1007299 14.1428571 26.1007299 9 8.95036496 8.52380952 8.95036496 8.52380952 27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.869,37.465 L8.729,37.465 C9.49900385,37.465 10.0746648,37.6208318 10.456,37.9325 C10.8373352,38.2441682 11.028,38.7409966 11.028,39.423 C11.028,39.8703356 10.9565007,40.2223321 10.8135,40.479 C10.6704993,40.735668 10.4450015,40.9483325 10.137,41.117 C10.8556703,41.3956681 11.215,41.9786622 11.215,42.866 C11.215,44.2886738 10.4156747,45 8.817,45 L5.869,45 L5.869,37.465 Z M8.729,41.711 L7.09,41.711 L7.09,43.944 L8.751,43.944 C9.15433535,43.944 9.45683232,43.8596675 9.6585,43.691 C9.86016767,43.5223325 9.961,43.2326687 9.961,42.822 C9.961,42.4113313 9.84366784,42.1235008 9.609,41.9585 C9.37433216,41.7934992 9.08100176,41.711 8.729,41.711 Z M8.663,38.521 L7.09,38.521 L7.09,40.677 L8.707,40.677 C9.42567026,40.677 9.785,40.3066704 9.785,39.566 C9.785,38.8693299 9.41100374,38.521 8.663,38.521 Z M12.601,45 L12.601,37.465 L13.822,37.465 L13.822,45 L12.601,45 Z M20.334,37.465 L20.334,38.554 L18.211,38.554 L18.211,45 L16.979,45 L16.979,38.554 L14.834,38.554 L14.834,37.465 L20.334,37.465 Z M24.987,37.465 L26.857,45 L25.625,45 L25.218,43.383 L22.325,43.383 L21.918,45 L20.697,45 L22.556,37.465 L24.987,37.465 Z M24.052,38.488 L23.502,38.488 L22.567,42.305 L24.976,42.305 L24.052,38.488 Z",
    id: "BITA",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBitaMethodologyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Bita_-_Methodology_-_Icon.d0b043cc.svg";
export { ForwardRef as ReactComponent };